var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_vm._m(0)]):_c('div')
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen flex justify-center items-center fixed inset-0"},[_c('div',{staticClass:"bg-white text-center w-96 h-96 shadow flex justify-center items-center"},[_c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin text-5xl text-green"}),_vm._v(" "),_c('p',[_vm._v("Mohon tunggu...")])])])])
}]

export { render, staticRenderFns }